import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SignalsStoreService } from '../../signals-store.service';
import { formatCurrency, formatCurrencyToAmount } from '../../utils/formatting';
import { ResolutionService } from '../../resolution.service';
import { CurrencyInputDirective } from '../../directives/currency-input.directive';
import { NotificationService } from '../../notification/notification.service';

@Component({
  selector: 'app-donation-skippable',
  imports: [
    MatRadioModule,
    CommonModule,
    FormsModule,
    CurrencyInputDirective
  ],
  templateUrl: './donation-skippable.component.html',
  styleUrl: './donation-skippable.component.scss'
})
export class DonationSkippableComponent {
  private activeModal = inject(NgbActiveModal);
  signalsStoreService = inject(SignalsStoreService)
  private resolutionService = inject(ResolutionService);
  private notificationService = inject(NotificationService);

  currentDonationAmount = (+this.signalsStoreService.totalOrderAmount()).toFixed(2)
  donationAmount = computed(() => this.signalsStoreService.donationAmountSkippable() || '')
  selectedOption: string = 'DONATE_FULL_AMOUNT';

  isMobile = computed(() => this.resolutionService.isMobile());

  donate() {
    const selectedDonationAmount = this.selectedOption === 'DONATE_FULL_AMOUNT'
      ? this.currentDonationAmount
      : this.signalsStoreService.donationAmountSkippable();
    let amount = 0;
    let value = selectedDonationAmount as string;


    if (value && value.endsWith('.'))
      value = value.slice(0, -1);

    const parts = value.split('.');

    if (parts.length === 1)
      value += '.00';
    else if (parts[1].length === 1)
      value += '0';

    amount = formatCurrencyToAmount(value);

    if (!amount) {
      return this.notificationService.show({
        text: 'Please enter a valid amount',
        type: 'error',
      });
    }

    this.signalsStoreService.donationAmountSkippable.set(amount)
    this.activeModal.close({
      isDonationCanceled: false,
      donationAmount: amount
    });
  }

  closeModal() {
    this.signalsStoreService.donationAmountSkippable.set(0.00)
    this.activeModal.close({
      isDonationCanceled: false,
      donationAmount: 0.00
    });
  }

  cancel() {
    this.activeModal.close({
      isDonationCanceled: true
    });
  }
}
